import { usersApi } from '../api/usersApi'

export const deleteUser = async (userId: string) => {
  try {
    const { data } = await usersApi.deleteUser(userId)
    return data
  } catch (error) {
    console.error(`Error deleting users: `, error)
    throw error
  }
}
